import { Component, effect, input, output, signal, ViewChild } from '@angular/core';
import { PatientBehaviorModel, PatientTargetModel } from '../../core/api/models';
import { SelectItem } from 'primeng/api';
import { StaffApiService, SupervisorApiService } from '../../core/api/services';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { MultiSelectChangeEvent } from 'primeng/multiselect';
import { Utils } from '../../core/utils';
import { MixedGraphComponent } from './mixed-graph/mixed-graph.component';
import { PatientDataFacadeService } from '../../core/services/patient-data-facade.service';

@Component({
  selector: 'app-mixed',
  templateUrl: './mixed.component.html',
  styleUrl: './mixed.component.css',
  standalone: false,
})
export class MixedComponent {
  @ViewChild('mixedGraph') mixedGraphComponent!: MixedGraphComponent;

  patientID = input.required<string>();

  isLoading: boolean = false;

  selectableTargets = signal<SelectItem[]>([]);
  selectedTargets = signal<PatientTargetModel[]>([]);

  selectableBehaviors = signal<SelectItem[]>([]);
  selectedBehaviors = signal<PatientBehaviorModel[]>([]);

  constructor(
    private supervisorApiService: SupervisorApiService,
    private staffApiService: StaffApiService,
    private router: Router,
    private patientDataFacade: PatientDataFacadeService
  ) {
    effect(() => {
      if (this.patientID()) {
        this.loadData();
      } else {
        this.router.navigate(['/select-patient']);
      }
    });
  }

  loadData() {
    this.isLoading = true;

    const getTargetsObservable = this.patientDataFacade.getTargets(Number(this.patientID()), { onlyActive: false });
    const getBehaviorsObservable = this.staffApiService.GetPatientBehaviors({ patientID: Number(this.patientID()) });

    forkJoin({
      targets: getTargetsObservable,
      behaviors: getBehaviorsObservable
    }).subscribe({
      next: (result) => {
        this.selectableTargets.set(result.targets.map(target => ({ text: target.TargetName + ' (' + Utils.patientTargetTypeLabel(target.TargetType!) + ')', value: target })));
        this.selectableBehaviors.set(result.behaviors.map(behavior => ({ text: behavior.PatientBehaviorName + ' (' + Utils.patientBehaviorTypeLabel(behavior.BehaviorType!) + ')', value: behavior })));
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching data', error);
        this.isLoading = false;
      }
    });
  }

  onGraphClick() {
    if (this.mixedGraphComponent) {
      this.mixedGraphComponent.loadDataForGraph();
    }
  }

}
